export const getGridStyles = (isSaturdayEnabled: boolean) => {
  const weekGridSize = isSaturdayEnabled ? '6' : '5';
  const sixDaysWeekGrid = "'week main main main main main main'";
  const fiveDaysGridWeek = "'week main main main main main'";
  const sixDaysMonthGrid = [
    "'. day-1 day-2 day-3 day-4 day-5 day-6'",
    "'week-0 main main main main main main'",
    "'week-1 main main main main main main'",
    "'week-2 main main main main main main'",
    "'week-3 main main main main main main'",
    "'week-4 main main main main main main'",
    "'week-5 main main main main main main'",
  ].join('');
  const fiveDaysMonthGrid = [
    "'. day-1 day-2 day-3 day-4 day-5'",
    "'week-0 main main main main main'",
    "'week-1 main main main main main'",
    "'week-2 main main main main main'",
    "'week-3 main main main main main'",
    "'week-4 main main main main main'",
  ].join('');
  return {
    '--week-grid-size': weekGridSize,
    '--week-grid-template-area': isSaturdayEnabled ? sixDaysWeekGrid : fiveDaysGridWeek,
    '--month-grid-template-area': isSaturdayEnabled ? sixDaysMonthGrid : fiveDaysMonthGrid,
  };
};
